import script from "./PlaylistCardSkeletonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistCardSkeletonLoader.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistCardSkeletonLoader.vue?vue&type=style&index=0&id=4b9b65c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9b65c8"]])

export default __exports__